import React from 'react';

const sections = [
  ['Information we collect', 'When you use our Guest Hub, booking pages or newsletter forms, we may collect your first name, email address, the property you stayed at and which page you used (for example Wi-Fi or Guidebook).'],
  ['How we use it', 'We use this information to give you access to guest resources, send occasional travel tips and exclusive offers (only if you opt in), and improve our properties and services. We never sell your personal information.'],
  ['Email marketing', 'Our emails are sent through Mailchimp. Every email includes an unsubscribe link, and you can also unsubscribe at any time by emailing capitolviewstays@gmail.com with the subject "Unsubscribe".'],
  ['Analytics', 'We use Google Analytics to understand how visitors use our website. This data is aggregated and does not identify you personally.'],
  ['Your rights', 'You may request access to, correction of, or deletion of your personal information at any time by contacting us.'],
  ['Contact', 'Capitol View Stays, Washington, DC. Email: capitolviewstays@gmail.com. Phone: (571) 507-5650.'],
];

export default function PrivacyPolicy() {
  return (
    <div data-testid="privacy-policy-page" className="bg-slate-50 pt-32 pb-20">
      <div className="max-w-3xl mx-auto px-4">
        <h1 className="text-4xl sm:text-5xl font-serif font-bold text-slate-900 mb-3">Privacy Policy</h1>
        <p className="text-slate-500 text-sm mb-10">Last updated June 2026</p>
        <div className="space-y-8">
          {sections.map(([title, body]) => (
            <section key={title}>
              <h2 className="text-lg font-semibold text-slate-900 mb-2">{title}</h2>
              <p className="text-slate-600 leading-relaxed">{body}</p>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
